globalThis["__INTERFERE_RELEASE_SLUG__"] = "rel_0091d5424061a801";
globalThis["__INTERFERE_BUILD__"] = true;
globalThis["__INTERFERE_PUBLIC_KEY__"] = "interfere_pub_us_316075dc9bef4579bd4ee18491b5d0fb";
globalThis["__INTERFERE_ENVIRONMENT__"] = "production";
globalThis["__INTERFERE_SERVER_TRACING__"] = "drain";
globalThis["__INTERFERE_LOG_SOURCING__"] = "drain";
globalThis["__INTERFERE_PLUGINS__"] = {"errors":true,"device":true,"pageEvents":true,"rageClick":true,"replay":true,"logs":true};
import { init } from "@interfere/next/instrument-client";

init();
